import { endsWith, get, isEmpty, some } from 'lodash'

const isStudentWithOnlyHighSchoolEmails = function (user) {
  if (isEmpty(get(user, 'HighSchool.EmailDomains'))) {
    return false
  }

  return (
    isEmpty(user.BackupEmail) &&
    some(user.HighSchool.EmailDomains, function (domain) {
      return endsWith(user.Email, '@' + domain)
    })
  )
}

const hasCleverGeneratedEmail = function (user) {
  return user.Email.endsWith('-cleveruser@scoir.com') && isEmpty(user.BackupEmail)
}

const hasClassLinkGeneratedEmail = function (user) {
  return user.Email.endsWith('-classlinkuser@scoir.com') && isEmpty(user.BackupEmail)
}

const isCleverStudentMissingAlternateEmail = function (user) {
  return (
    (isStudentWithOnlyHighSchoolEmails(user) || hasCleverGeneratedEmail(user)) &&
    get(user, 'HighSchool.SISConfig.StudentSyncPerformed', false)
  )
}

const isClassLinkStudentMissingAlternateEmail = function (user) {
  return hasClassLinkGeneratedEmail(user) && get(user, 'HighSchool.SISConfig.ClassLink.IsEnabled', false)
}

export default {
  HSE: (user) => {
    const isHSOrAlumn = user?.Profile?.GraduationYear <= user?.HighSchool?.CurrentSeniorYear + 3
    return (
      isHSOrAlumn &&
      !get(user, 'Preferences.HighSchoolEmailDomain', false) &&
      isStudentWithOnlyHighSchoolEmails(user) &&
      !get(user, 'HighSchool.SISConfig.StudentSyncPerformed', false)
    )
  },
  CHSE: (user) => {
    const isHSOrAlumn = user?.Profile?.GraduationYear <= user?.HighSchool?.CurrentSeniorYear + 3
    return (isHSOrAlumn && isCleverStudentMissingAlternateEmail(user)) || isClassLinkStudentMissingAlternateEmail(user)
  },
}
